<template>
    <BApp>
        <GlobalErrorsInit />
        <VersionChecker>
            <RouterView />
        </VersionChecker>
        <HelpDrawer />
    </BApp>
</template>

<script setup lang="ts">
import { useOrganisationStore } from '@/stores/organisationStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useMenuBadgesFromCounts } from '@/queries/counts';
import GlobalErrorsInit from '@/components/GlobalErrorsInit.vue';
import VersionChecker from '@/components/VersionChecker.vue';
import HelpDrawer from '@/components/help/HelpDrawer.vue';
import { watch } from 'vue';
import { echo } from '@laravel/echo-vue';
import type { OrganisationNotificationBroadcast } from '@/queries/notifications';
const organisationStore = useOrganisationStore();
const notificationStore = useNotificationStore();

useMenuBadgesFromCounts();

watch(
    () => organisationStore.current_organisation?.id,
    (newId, oldId) => {
        const echoInstance = echo();

        if (oldId) {
            echoInstance.leave(`organisation.${oldId}`);
        }

        if (newId) {
            notificationStore.fetchOrganisationNotifications(organisationStore.current_organisation);

            echoInstance
                .private(`organisation.${newId}`)
                .listen('OrganisationNotificationCreated', (payload: OrganisationNotificationBroadcast) => {
                    notificationStore.applyBroadcastNotification(payload);

                    if (payload.notification === null) {
                        notificationStore.fetchOrganisationNotifications(organisationStore.current_organisation);
                    }
                });
        }
    },
    { immediate: true },
);
</script>

<style lang="scss"></style>
